export enum ProductKind {
  SPORT = 'SPORT',
  MITE = 'ANTIMITE',
}
